var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9576 13.2304C10.7013 14.2138 9.11911 14.8 7.4 14.8C3.31309 14.8 0 11.4869 0 7.4C0 3.31309 3.31309 0 7.4 0C11.4869 0 14.8 3.31309 14.8 7.4C14.8 9.11911 14.2138 10.7013 13.2304 11.9576L18.0363 16.7635C18.3878 17.115 18.3878 17.6848 18.0363 18.0363C17.6848 18.3878 17.115 18.3878 16.7635 18.0363L11.9576 13.2304ZM1.8 7.4C1.8 4.30721 4.30721 1.8 7.4 1.8C10.4928 1.8 13 4.30721 13 7.4C13 8.93717 12.3807 10.3297 11.3779 11.3416C11.3717 11.3475 11.3656 11.3534 11.3595 11.3595C11.3534 11.3656 11.3475 11.3717 11.3416 11.3779C10.3297 12.3807 8.93717 13 7.4 13C4.30721 13 1.8 10.4928 1.8 7.4Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.60cd089b29d59a7bdcd40cfe62abc8d7.svg";
export { ForwardRef as ReactComponent };